import React from 'react';
import Content from './content/index.tsx';
import SelectItemTypeModal from './view.tsx';

type Props = {
	onClose: () => void;
	onAddLink: () => void;
	onAddRepo: () => void;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => (
	<SelectItemTypeModal
		onClose={props.onClose}
		Content={Content}
		onAddLink={props.onAddLink}
		onAddRepo={props.onAddRepo}
	/>
);
